import React from 'react'

import Slider from '@peracto/peracto-editor-ui/dist/Slider'
import Select from '@peracto/peracto-editor-ui/dist/Select'

const MapForm = ({ onChange, state: { url = '', aspectRatio = '1:1', zoomLevel = 10 } }) => {
    const aspectRatioOptions = [
        { label: '1:1', value: '1:1' },
        { label: '16:9', value: '16:9' },
        { label: '4:3', value: '4:3' },
        { label: '2:1', value: '2:1' },
    ]

    return (
        <>
            <div className="form-group">
                <label className="!mb-1">Map Embed Code</label>
                <textarea
                    className="form-control"
                    rows={6}
                    value={url}
                    onChange={e => onChange({ url: e.target.value })}
                />
            </div>

            <Select
                label="Aspect Ratio"
                value={aspectRatio}
                onChange={e => onChange({ aspectRatio: e.value })}
                options={aspectRatioOptions}
            />

            <Slider
                label="Zoom Level"
                min={1}
                max={40}
                step={1}
                value={zoomLevel}
                onChange={e => onChange({ zoomLevel: e.target.value })}
            />
        </>
    )
}

export default MapForm
